//
// Module for Third Party Tab
//
rs.module("content/thirdparties/thirdpartytab",

    ["common/select-helper", "controls/components/event-banner"],

    function (selectHelper, eventBanner) {

        // ensure errors are not cleared on postback,
        // only execute on selection
        var _executeSelectionChanged;

        // Initialize the module
        function initialize(jsSelectors, lrsGridApi, columnIds, ajaxUrl) {

            var fundForm = $.js(jsSelectors.fundAssociationForm);

            var addFundLink = fundForm.js(jsSelectors.addFundLink);

            var fundUpdateToken = fundForm.js(jsSelectors.fundUpdateToken);
            var rolodexKey = fundForm.js(jsSelectors.rolodexKey);
            var fundSelect = fundForm.js(jsSelectors.fundKey);
            var fundSelectHelper = selectHelper.getHelper(fundSelect);
            var fundHiddenField = fundForm.js(jsSelectors.fundKeyHidden);
            var effectiveDate = fundForm.js(jsSelectors.effectiveDate);
            var terminationDate = fundForm.js(jsSelectors.terminationDate);

            var cancelFundButton = fundForm.js(jsSelectors.cancelFundButton);

            lrsGridApi.selectionChanged(function (values, rows) {
                if (_executeSelectionChanged && values.length > 0) {
                    OnGridRowSelect(rows[0]);
                }

                _executeSelectionChanged = true;
            });

            // clear errors and grid selection, default values when add is clicked
            addFundLink.click(function () {
                ClearErrorsAndInfoMessages();

                lrsGridApi.selectedValues = null;

                fundSelectHelper.setDisabled(false);
                fundHiddenField.prop("disabled", true);

                fundUpdateToken.val('')
                rolodexKey.val("-1");
                fundSelectHelper.setValue('');
                fundHiddenField.val('');
                effectiveDate.val('');
                terminationDate.val('');
            });

            // reset grid selection to first row
            cancelFundButton.click(function () {
                // if already on first row, selectionChanged won't be fired
                // so manually call reset for row
                if (lrsGridApi.agGridApi.getSelectedNodes().length && lrsGridApi.agGridApi.getSelectedNodes()[0].childIndex == 0) {
                    OnGridRowSelect(lrsGridApi.selectedRows[0]);
                } else {
                    lrsGridApi.selectFirstRow();
                }
            });

            // clear errors and messages and set fields for new selection
            function OnGridRowSelect(selectedRow) {
                ClearErrorsAndInfoMessages();

                // disable in case fund selected while in "add mode"
                fundSelectHelper.setDisabled(true);
                fundHiddenField.prop("disabled", false);

                $.get(
                    ajaxUrl,
                    { rolodexKey: selectedRow[columnIds.rolodexKey] },

                    function (data) {
                        fundUpdateToken.val(data.updateToken);
                        rolodexKey.val(data.rolodexKey);
                        fundSelectHelper.setValue(data.fundKey);
                        fundHiddenField.val(data.fundKey);
                        effectiveDate.val(data.effectiveDate ? new Date(data.effectiveDate).toISODateString() : null);
                        terminationDate.val(data.terminationDate ? new Date(data.terminationDate).toISODateString() : null);
                    }
                );
            }

            // clear messages and client validation of fund fields
            function ClearErrorsAndInfoMessages() {
                eventBanner.removeAllMessages();

                fundUpdateToken.clearErrors();
                rolodexKey.clearErrors();
                fundSelect.clearErrors();
                fundHiddenField.clearErrors();
                effectiveDate.clearErrors();
                terminationDate.clearErrors();
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);